import React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useAttachDepartmentPermissionTagsTranslation } from '../i18n';
import type { AttachDepartmentPermissionTagsProps } from '../types';
import { AttachDepartmentPermissionTagsDropdown } from './AttachDepartmentPermissionTagsDropdown';

type AttachDepartmentPermissionTagsButtonProps =
  AttachDepartmentPermissionTagsProps &
  Omit<ButtonProps, 'onClick'>;

const displayName = 'AttachDepartmentPermissionTagsButton';
const testid = buildTestid(displayName);

function AttachDepartmentPermissionTagsButton({
  departmentId,
  'data-testid': dataTestId = undefined,
  disabled = false,
  ...props
}: AttachDepartmentPermissionTagsButtonProps): React.JSX.Element {
  const { t } = useAttachDepartmentPermissionTagsTranslation();

  return (
    <AttachDepartmentPermissionTagsDropdown
      departmentId={departmentId}
      disabled={disabled}
    >
      <Button
        icon={<PlusIcon />}
        variant="flat"
        {...testid(dataTestId)}
        {...props}
      >
        {t('title')}
      </Button>
    </AttachDepartmentPermissionTagsDropdown>
  );
}

AttachDepartmentPermissionTagsButton.displayName = displayName;

export { AttachDepartmentPermissionTagsButton };
